import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance2,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  REPORTING_TRANSACTIONS,
  NOTIFICATION,
} from '../actionTypes';

const fetchTransactionsReporting = async (payload) => {
  const params = payload.payload;
  if (params?.query) {
    return axiosAuthInstance2.get(`${API_END_POINTS.REPORTING_TRANSACTIONS}${params?.query}`);
  }
  return axiosAuthInstance2.get(`${API_END_POINTS.REPORTING_TRANSACTIONS}`);
};

export function* getTransactionsReporting(action) {
  try {
    const { data } = yield call(fetchTransactionsReporting, action.payload);
    yield put({ type: REPORTING_TRANSACTIONS.SUCCESS, payload: data });
  } catch (e) {
    yield put({ type: REPORTING_TRANSACTIONS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  }
}
